import items from './items';
import simpleViewAttributes from './simpleViewAttributes';
import leadGate from './leadGate';
import siteConfigProperties from './siteConfigProperties';

const root = {
	items,
	simpleViewAttributes,
	leadGate,
	siteConfigProperties
};

export default root;
